import { COLOR_ERROR } from "./theme";
import styled from "@emotion/styled";

const StyledAsterisk = styled.span`
  color: ${COLOR_ERROR};
`;

const RequiredAsterisk = () => {
  return <StyledAsterisk>*</StyledAsterisk>;
};

export default RequiredAsterisk;
